<template>
	<div class="margin-left">
		<div class="from">
			<el-form :model="rise" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="抬头选择" prop="capacity">
					<div class="header-item" @click="fect('manage')" v-if="typeData">
						<div class="">
							<p class="text-lg text-theme text-left">{{typeData.type | fitytype}}</p>
							<div class="flex justify-start margin-top-sm">
								<span class="text-999 text-sm margin-right-sm">开票对象</span>
								<span>{{typeData.name}}</span>
							</div>
							<div class="flex justify-start">
								<span class="text-999 text-sm margin-right-sm">发票类型</span>
								<span>{{typeData.invoice_type | fityinvoice}}</span>
							</div>
						</div>
						<img @click.stop="edit(typeData)" class="pointer edite" src="../../../assets/img/edite.png" >
					</div>
					<p class="flex align-center pointer" @click="fect('manage')" v-else>
						<img src="../../../assets/img/you_icon.png" >
						<span class="text-df text-theme">选择抬头</span>
					</p>
					<p class="flex align-center pointer" @click="fect('addinvoice')" v-if="!typeData">
						<img src="../../../assets/img/you_icon.png" >
						<span class="text-df text-theme">创建抬头</span>
					</p>
				</el-form-item>
				<div class="flex align-center money margin-bottom">
					<p class="margin-right-sm text-df">当前可开票金额</p>
					<p class="text-theme text-df text-bold">{{rise.money}}元</p>
				</div>
				<el-form-item label="发票内容" prop="cont">
					<el-select v-model="rise.cont" placeholder="请选择" class="text-theme">
						<el-option :label="item" :value="index+1" v-for="(item,index) in array" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="发票类型" prop="type" v-if="typeData">
					<div class="text-right type text-theme">{{typeData.invoice_type | fityinvoice}}</div>
				</el-form-item>
				<el-form-item label="联系电话" prop="phone">
				  <el-input v-model="rise.phone" placeholder="请输入联系电话"></el-input>
				</el-form-item>
				<el-form-item label="电子邮箱" prop="email">
				  <el-input v-model="rise.email" placeholder="请输入电子邮箱"></el-input>
				</el-form-item>
				<el-form-item>
				    <el-button type="primary" @click="submitForm('ruleForm')">保存提交</el-button>
				  </el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			//检测抬头选择
			var validateCapacity = (rule, value, callback)=>{
				if (!value) {
					return callback(new Error('请选择抬头'));
				}
					callback();
			}
			//发票内容
			var validateCont = (rule, value, callback)=>{
				if (!value) {
					return callback(new Error('请选择发票内容'));
				}
					callback();
			}
			//检测注册电话
			var validatePhone = (rule, value, callback)=>{
				console.log(value);
				if (!value) {
					return callback(new Error('请输入注册电话'));
				}
				callback();
			}
			return {
				array:[],
				typeData:null,
				rise:{
					capacity:'',//抬头选择
					money:'',//当前可开票金额
					cont:'',//发票内容
					type:'',//发票类型
					address:'',//联系电话
					email:'',//银行账号
					
				},
				rules: {
					capacity: [{
						validator: validateCapacity,
						trigger: 'change'
					}],
					cont:[{
						validator: validateCont,
						trigger: 'change'
					}],
					phone:[{
						validator: validatePhone,
						trigger: 'blur'
					}],
					email:[
						{  message: '请输入邮箱地址', trigger: 'blur' },
						{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
					]
					 
				}
			}
		},
		created() {
			this.getInvoicePrice()
			
			Bus.$on('backData',data=>{
				this.typeData = data;
			})
		},
		destroyed() {
			Bus.$off()
		},
		methods: {
			/**
			 * 获取可开金额和内容类目
			 * */
			getInvoicePrice(){
				this.ajax('get', '/api/invoice/getInvoicePrice', {},res => {
					this.rise.money = res.data.price
					this.array = res.data.content
				})
			},
			//编辑
			edit(item){
				this.fect('addinvoice')
				setTimeout(()=>{
					Bus.$emit('edit',item)
				},500)
			},
			/**
			 * 跳转对应组件
			 * type string 对应组件名
			 * */
			fect(type) {
				let typeq = {
					type: type,
					typeone: 'apply'
				}
				this.$emit('gettype', typeq)
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					// 
					this.addsub()
				  } else {
					console.log('error submit!!');
					return false;
				  }
				});
			  },
			addsub(){
				let data={
					head_id:this.typeData.id,
					price:this.rise.money,
					content:this.rise.cont,
					type:this.typeData.type,
					phone:this.rise.phone,
					address:this.rise.address,
					email:this.rise.email
				}
				this.ajax('post', '/api/invoice/add',data,res => {
					let info = {
						type:this.typeData.type,
						content:this.rise.cont,
						price:this.rise.money,
					}
					Bus.$emit('showsub',info)
					setTimeout(()=>{
						this.$emit('showsub')
					},500)
				})
			}
		},
		filters:{
			fitytype(val){
				switch (val) {
					case 2:
						return '企业'
						break;
					case 1:
						return '个人'
						break;
					default:
						break;
				}
			},
			fityinvoice(val){
				switch (val) {
					case 1:
						return '增值税普通发票'
						break;
					case 2:
						return '增值税专用发票'
						break;
					default:
						break;
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.header-item{
		width: 373px;
		height: 136px;
		border: 1px solid #E6E6E6;
		background: linear-gradient(0deg, #EEF7F6 0%, #F8FAFA 100%);
		border-radius: 20px;
		padding: 18px 19px ;
		position: relative;
		.edite{
			position: absolute;
			width: 25px;
			height: 23px;
			right: 19px;
			bottom: 21px;
		}
		div{
			line-height: 1.5;
		}
	}
	.money{
		padding-left: 16px;
	}
	.from{
		width: 921px;
		/* height: 878px; */
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
		padding: 71px 126px 104px;
	}
	.type{
		width: 567px;
		height: 54px;
		line-height: 54px;
		padding-right: 10px;
		background: rgba(230,230,230,0.3);
		border: 1px solid #E6E6E6;
		border-radius: 8px;
	}
	/deep/ .el-select{
		width: 100%;
		color: #09827B;
	}
	/deep/ .el-select>.el-input>.el-input__inner{
		color: #09827B;
	}
	
	/deep/ .el-input__inner{
		text-align: right;
		height: 54px;
		background: rgba(230,230,230,0.3);
		border: 1px solid #E6E6E6;
		border-radius: 8px;
	}
	/deep/ .el-form-item__label{
		font-size: 18px;
	}
	/deep/ .el-button{
		width: 383px;
		height: 60px;
		// line-height: 60px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2);
		border-radius: 30px;
		margin-top: 70px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/invoice/apply.vue